import React, {useState} from "react";
import placeholder from "../../Assets/Images/placeholder.png"
import {useSelector} from "react-redux";
import {RootState} from "../../Store/Reducers";
import {Customer} from "../../Models/Customer";
import {Input, InputGroup, InputGroupAddon} from "reactstrap";
import ButtonAction from "./ButtonAction";
import {faSearch} from "@fortawesome/free-solid-svg-icons";
import {onSearchShipment} from "../../Utils/Utils";
import {useHistory} from "react-router-dom";

type Props = {
  name?:string;
}

const SlideMenuTopInfoComponent : React.FC <Props> = () => {

  const [consecutive, setConsecutive] = useState<string>('');
  const {CompanyReducer: { company_selected, branch_selected }, authReducer: {user, logged}} = useSelector((state: RootState) => state);
  const history = useHistory();

  return(
    <div className="slide-menu-container">
      <img className="slide-menu-avatar" src={placeholder} alt=""/>
      {
        logged &&
        <>
          <span className="slide-menu-name">{user?.name || 'Usuario' }</span>
          <span className="slide-menu-branch">{(branch_selected as Customer)?.name || (company_selected as Customer)?.name || '' }</span>
        </>
      }
      <InputGroup>
        <Input type="number" placeholder="Numero de Guia"
               name="consecutive" value={consecutive}
               onChange={(e) => setConsecutive(e.target.value)}
        />
        <InputGroupAddon addonType="append">
          <ButtonAction action={{
            icon: faSearch,
            color: 'primary',
            onClick: () => onSearchShipment(history, consecutive)
          }}/>
        </InputGroupAddon>
      </InputGroup>
    </div>
  );
};

export default SlideMenuTopInfoComponent;
